import { isPlatformBrowser, NgIf, CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit, Output, EventEmitter, PLATFORM_ID, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { IFeasibility, IPackages } from 'app/core/shared-services/interfaces.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { NgClass } from '@angular/common';
import { CoverageVisibilityService } from '../landing/home/coverage-visibility.service';


@Component({
  selector: 'app-google-search-bar',
  standalone: true,
  imports: [FuseCardComponent, NgIf, MatButtonModule, MatProgressSpinnerModule, NgClass, CommonModule],
  templateUrl: './google-search-bar.component.html',
  styleUrl: './google-search-bar.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class GoogleSearchBarComponent implements OnInit, AfterViewInit {

  @Input() headerTextColor: string;
  @Input() addressVerification: boolean = false;
  @Input() installationAddress: boolean = false;
  @Input() hasWhiteBackground: boolean = false;
  
  @Output() addressSelected = new EventEmitter<string>();

  @ViewChild('searchInput') searchInputRef: ElementRef;

  public location: HTMLElement;
  private coords: any;
  public loading: boolean = false;

  private feasibilityResult: IFeasibility;
  private feasibility: any;
  private LeadEntityID: number;

  public packagesResult: IPackages;
  private packages: any;

  private referrer: string;

  public isScreenSmall: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  public addVerificationLoading: boolean = false;
  private mapsPlace: any; 
  private addressStripped: any;
  public isValidAddress: boolean;

  private autocomplete!: google.maps.places.Autocomplete;

  // Getter to safely access search input value
  get searchInputValue(): string {
    return this.searchInputRef?.nativeElement?.value || '';
  }
  private autocompleteListener!: google.maps.MapsEventListener;



  constructor(

    private _webStorage: WebStorage,
    private _sharedMethods: SharedMethodsModule,
    private router: Router,
    private _gtmService: GtmService,
    private changeDetector: ChangeDetectorRef,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    
    @Inject(PLATFORM_ID) private platformId: any,
    private coverageVisibilityService: CoverageVisibilityService

  ){}

  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {

      // Subscribe to media changes
            this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Check if the screen is small
           
                this.isScreenSmall = !matchingAliases.includes('md');
            });

      if(sessionStorage.getItem('currentURL')) {
        if(sessionStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = sessionStorage.getItem('currentURL')
          sessionStorage.setItem('currentURL', window.location.href);
          sessionStorage.setItem('previousURL', this.referrer);
        }
      } else {
        sessionStorage.setItem('currentURL', window.location.href);
      }

        // try getting users location
        navigator.geolocation.getCurrentPosition(res => {
          this.coords = res.coords;
        })
    }
  }

  ngAfterViewInit(): void
  { 

    const observer = new MutationObserver(() => {
      const input = document.getElementById('searchTextField') as HTMLInputElement;
      if (input) {
        this.getPlaceAutocomplete(input);
        observer.disconnect(); // stop observing once input is ready
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
    
  }

  ngOnChanges(): void
  { 

    const observer = new MutationObserver(() => {
      const input = document.getElementById('searchTextField') as HTMLInputElement;
      if (input) {
        this.getPlaceAutocomplete(input);
        observer.disconnect(); // stop observing once input is ready
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
    
  }

  /**
     * On destroy
     */
  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();

      if (this.autocompleteListener) {
        google.maps.event.removeListener(this.autocompleteListener);
      }
  }

  // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
  
    /**
     * Get Places AutoComplete
     */
  
    public getPlaceAutocomplete(input: any) {
      
      if (isPlatformBrowser(this.platformId)) {
  
        // sessionStorage.removeItem("LeadEntityId");
        // sessionStorage.removeItem("AvailablePackages");
        // this._webStorage.StoredLead.next(0);
    
        const sessionToken = new google.maps.places.AutocompleteSessionToken()
        const options = {
          componentRestrictions: { country: 'ZA' },
          types: ['geocode', 'establishment',],
          fields: ['formatted_address', 'address_components', 'geometry'],
          sessionToken: sessionToken
        }
        this.autocomplete = new window.google.maps.places.Autocomplete(input, options);
  
        this.autocompleteListener = this.autocomplete.addListener('place_changed', async () => {
    
          this.mapsPlace = this.autocomplete.getPlace();
          const streetNumber = await this.consumeGoogleAddress(this.mapsPlace, 'street_number');
          const streetName = await this.consumeGoogleAddress(this.mapsPlace, 'route');

          if(streetName && streetNumber) {
            this.isValidAddress = true;
            this.addVerificationLoading = false;

          } else {

            this.isValidAddress = false;
            this.addVerificationLoading = false;

          }

          if(!this.addressVerification) {
            this.invokeEvent();
          }
    
        });

        setTimeout(() => {
          const pacContainers = document.querySelectorAll('.pac-container');
          const matDialog = document.querySelector('mat-dialog-container');
        
          if (pacContainers.length > 0 && matDialog) {
            pacContainers.forEach(pac => {
              if (!matDialog.contains(pac)) {
                matDialog.appendChild(pac);
                pac.setAttribute('data-attached', 'true'); // optional for tracking
              }
            });
          }
        }, 300); 
  
      }
    }

    /**
   * Button - Get current location
   */

  btn_getLocation() {
    this.getLocation().then((coords) => {
      if (coords) {
        this.loading = true; //Show spinner while loading next page
        this.getCurrentLocation();
        this.getCurrentLocation();
      }
    });
  }

    /**
   * Installation Only: Button - Get current location
   */

  installation_btn_getLocation() {
    this.getLocation().then(async  (coords) => {
      if (coords) {
        this.loading = true; //Show spinner while loading next page
        await this.getInstallationCurrentLocation();
        
      }
    });
  }

  /**
   * Installation Address Change: Button - Get current location for address change
   */
  installation_change_btn_getLocation() {
    this.getLocation().then(async (coords) => {
      if (coords) {
        this.coords = coords; // Set the coordinates
        this.loading = true; //Show spinner while loading next page
        await this.getInstallationChangeCurrentLocation();
      }
    });
  }

  /**
     * Get using my location
     */
  
    async getLocation() {
      try {
        //Promise needed for error handling
        const position: GeolocationPosition = await new Promise<GeolocationPosition>((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true, 
            timeout: 5000,             
            maximumAge: 0              
          });
        });
    
        const { latitude, longitude } = position.coords;
        return { latitude, longitude };
    
      } catch (error) {
        //Error handling
        let errorMessage = 'Unable to retrieve location.<br>';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage += '<br>Location access has been blocked in your browser.<br>Please enable it in your browser settings.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage += '<br>Location information is unavailable.';
            break;
          case error.TIMEOUT:
            errorMessage += '<br>Location request timed out.';
            break;
          default:
            errorMessage += '<br>An error occurred.';
        }
        
        //Display error to user
        Swal.fire({
          title: 'Oops!',
          html: errorMessage,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Okay',
          customClass: {
            confirmButton: 'text-lg text-black bg-accent',
          },
        });
        return null;
      }
    }

    // -----------------------------------------------------------------------------------------------------
      // @ Private methods
      // -----------------------------------------------------------------------------------------------------
    
      /**
       * Get current position
       */
    
      public async getCurrentLocation() {
    
        if (this.coords) {
          this.feasibility = await this._sharedMethods.geoCode(null, this.coords);
          if (this.feasibility.success) {
            this.feasibilityResult = this.feasibility.result;
            this.LeadEntityID = this.feasibilityResult.LeadEntityID;
 
            // sets the required info and checks interface
            if (this.feasibilityResult.Feasibility == 'Yes' || this.feasibilityResult.Feasibility == 'Maybe') {
              // feasibility is 'Yes' and values are set, now retrieve packages
              this.packages = await this._sharedMethods.getAvailablePackages(this.LeadEntityID);
              if (this.packages.success)
              {
                this.packagesResult = this.packages.result;
      
                this.goToPackages();
    
                this.coverageVisibilityService.hide();
              }
            } else {
         
        
              this.goToPackages();
              this.coverageVisibilityService.hide();
            }
          }
        }
    
      }
    
      /**
       * Invoke event
       */
    
      private async invokeEvent() {
        this.loading = true;
    
        const route = window.location.href;
        const path = this.router.url;
        this._gtmService.pushEvent({ 
          event: 'check_coverage', 
          page_url: route, 
          page_path: path, 
          page_title: 'home_page',
          page_referrer: this.referrer ? this.referrer : route});
        
        if (isPlatformBrowser(this.platformId)) {
          this.changeDetector.detectChanges();
    
          this._webStorage.SetCustomerGoogleAddress(this.mapsPlace);
    
          this.feasibility = await this._sharedMethods.geoCode(this.mapsPlace, null);

            if (this.feasibility.success) {
              this.feasibilityResult = this.feasibility.result;
              this.LeadEntityID = this.feasibilityResult.LeadEntityID;
         
              // sets the required info and checks interface
              if (this.feasibilityResult.Feasibility == 'Yes' || this.feasibilityResult.Feasibility == 'Maybe') {
      
                // feasibility is 'Yes' and values are set, now retrieve packages
                this.packages = await this._sharedMethods.getAvailablePackages(this.LeadEntityID);
      
                if (this.packages.success) {
                  this.packagesResult = this.packages.result;
              
                  if(this.addressVerification) {
                    location.reload();
                  } else if (this.installationAddress) {
                    this.handleInstallationPackagesNavigation();
                    this.coverageVisibilityService.hide();
                  } else {
                    this.goToPackages();
                    this.coverageVisibilityService.hide();
                  }
                }
              } else {
                if(this.addressVerification) {
                  location.reload();
                } else if (this.installationAddress) {
                  this.handleInstallationPackagesNavigation();
                  this.coverageVisibilityService.hide();
                } else {
                  this.goToPackages();
                  this.coverageVisibilityService.hide();
                }
              }
            }
        }
      }

      public consumeGoogleAddress(address: any, type: string) {
        let val: any = null;
        if (address.results) {
          this.addressStripped = address.results[0].address_components;
        } else {
          this.addressStripped = address.address_components;
        }
    
        this.addressStripped?.forEach((a: any) => {
          a.types.forEach((t: any) => {
            if (t == type) {
              val = a.short_name;
              return
            }
          })
        });
        return val
      }


      goToPackages(){
          sessionStorage.removeItem("LeadEntityId");
          sessionStorage.removeItem("LeadEntityID");
          sessionStorage.removeItem("AvailablePackages");
          sessionStorage.removeItem("cartInfo");
          this._webStorage.CartInfo.next(0);
 
          
          this._webStorage.SetLeadEntityID(this.LeadEntityID);
          this._webStorage.StorePackages(this.packagesResult);
          this.router.navigateByUrl('/packages');
      }

      /**
       * Get current position for installation address dialog
       */
      public async getInstallationCurrentLocation() {
        if (this.coords) {
          this.feasibility = await this._sharedMethods.geoCode(null, this.coords);
          if (this.feasibility.success) {
            this.feasibilityResult = this.feasibility.result;
            this.LeadEntityID = this.feasibilityResult.LeadEntityID;
 
            // sets the required info and checks interface
            if (this.feasibilityResult.Feasibility == 'Yes' || this.feasibilityResult.Feasibility == 'Maybe') {
              // feasibility is 'Yes' and values are set, now retrieve packages
              this.packages = await this._sharedMethods.getAvailablePackages(this.LeadEntityID);
              if (this.packages.success)
              {
                this.packagesResult = this.packages.result;
      
                this.handleInstallationPackagesNavigation();
    
                this.coverageVisibilityService.hide();
              }
            } else {
              this.handleInstallationPackagesNavigation();
              this.coverageVisibilityService.hide();
            }
          }
        }
      }

      /**
       * Handle packages navigation for installation address - emit event or navigate directly
       */
      private handleInstallationPackagesNavigation() {
        // console.log('handleInstallationPackagesNavigation called');
        // console.log('LeadEntityID:', this.LeadEntityID);
        // console.log('packagesResult:', this.packagesResult);
        
        // Check if we have valid data before proceeding
        if (!this.LeadEntityID || !this.packagesResult) {
          console.error('Missing required data - LeadEntityID or packagesResult');
          // Still emit the event to close dialog, but packages page will handle the error
          this.addressSelected.emit('packages');
          return;
        }
        
        // Store packages data first
        sessionStorage.removeItem("LeadEntityId");
        sessionStorage.removeItem("LeadEntityID");
        sessionStorage.removeItem("AvailablePackages");
        sessionStorage.removeItem("cartInfo");
        this._webStorage.CartInfo.next(0);
        
        this._webStorage.SetLeadEntityID(this.LeadEntityID);
        this._webStorage.StorePackages(this.packagesResult);
        
        // Emit event for dialog to handle or navigate directly
        this.addressSelected.emit('packages');
      }

      /**
       * Get installation address change current location using coordinates
       */
      public async getInstallationChangeCurrentLocation() {
        try {
          if (this.coords) {
            this.feasibility = await this._sharedMethods.geoCode(null, this.coords);
            if (this.feasibility.success) {
              this.feasibilityResult = this.feasibility.result;
              this.LeadEntityID = this.feasibilityResult.LeadEntityID;
   
              // sets the required info and checks interface
              if (this.feasibilityResult.Feasibility == 'Yes' || this.feasibilityResult.Feasibility == 'Maybe') {
                // feasibility is 'Yes' and values are set, now retrieve packages
                this.packages = await this._sharedMethods.getAvailablePackages(this.LeadEntityID);
                if (this.packages.success) {
                  this.packagesResult = this.packages.result;
        
                  this.handleInstallationChangePackagesNavigation();
      
                  this.coverageVisibilityService.hide();
                }
              } else {
                this.handleInstallationChangePackagesNavigation();
                this.coverageVisibilityService.hide();
              }
            }
          }
        } catch (error) {
          console.error('Error in getInstallationChangeCurrentLocation:', error);
        } finally {
          // Always turn off loading spinner
          this.loading = false;
        }
      }

      /**
       * Handle packages navigation for installation address change - emit event to close dialog
       */
      private handleInstallationChangePackagesNavigation() {
        // console.log('handleInstallationChangePackagesNavigation called');
        // console.log('LeadEntityID:', this.LeadEntityID);
        // console.log('packagesResult:', this.packagesResult);
        
        try {
          // Check if we have valid data before proceeding
          if (!this.LeadEntityID || !this.packagesResult) {
            console.error('Missing required data - LeadEntityID or packagesResult');
            // Still emit the event to close dialog, but packages page will handle the error
            this.addressSelected.emit('packages');
            return;
          }
          
          // Store packages data for the new address
          sessionStorage.removeItem("LeadEntityId");
          sessionStorage.removeItem("LeadEntityID");
          sessionStorage.removeItem("AvailablePackages");
          sessionStorage.removeItem("cartInfo");
          this._webStorage.CartInfo.next(0);
          
          this._webStorage.SetLeadEntityID(this.LeadEntityID);
          this._webStorage.StorePackages(this.packagesResult);
          
          // console.log('Address change data stored successfully, emitting packages event');
          // Emit event for dialog to handle address change navigation
          this.addressSelected.emit('packages');
        } catch (error) {
          console.error('Error in handleInstallationChangePackagesNavigation:', error);
          // Still emit event to close dialog even if there's an error
          this.addressSelected.emit('packages');
        }
      }

}
